import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { MetaNavItem, NavMenuType, PrimaryNavItem, UserAccountData } from '@hdms/shared/page-frame/types';

@Component({
  selector: 'shrd-pf-ft-burger-menu-secondary-footer',
  templateUrl: './burger-menu-secondary-footer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BurgerMenuSecondaryFooterComponent {
  @Input() userData: UserAccountData;
  @Input() menuItem: PrimaryNavItem | MetaNavItem;
  @Output() closeSecondaryMenu = new EventEmitter<void>();

  readonly menuTypes = NavMenuType;

  public closeContentCard(): void {
    this.closeSecondaryMenu.emit();
  }
}
